<template>
  <div class="section p-0">
    <enterprises />
    <config />
    <log />
  </div>
</template>

<script>
import Enterprises from "./enterprises/Index.vue";
import Config from "./config_file/Index.vue";
import Log from "./log/Index.vue";

export default {
  name: "SettingConfig",
  components: { Enterprises, Config, Log },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>

<style></style>
